export default function ContactButton(props) {
    return(
        <a href="/contact" className='z-20 rounded-full bg-gradient-to-r from-sky-400 hover:from-white to-fuchsia-600 hover:to-white'>
            <h2 className='px-8 py-2 w-full h-full text-white hover:text-transparent hover:bg-clip-text hover:bg-gradient-to-r hover:from-sky-500 hover:to-fuchsia-600'>{props.text}</h2>
        </a>
    );
}